module.exports = __webpack_public_path__ + "9de06497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/partnerships_pizzahut@2x.png
// module id = 1208
// module chunks = 0